import * as React from "react";
const SvgFiRrMusicNoteSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-music-note-slash_svg__a)">
      <path
        fill="#062147"
        d="M23.707 23.707a.997.997 0 0 1-1.414 0l-22-22A.999.999 0 1 1 1.707.293L13 11.586V4.5C13 2.02 15.02 0 17.5 0H20a1 1 0 1 1 0 2h-2.5A2.5 2.5 0 0 0 15 4.5v9.086l8.707 8.707a1 1 0 0 1 0 1.414m-9.597-5.183a1 1 0 0 0-1.197.754A3.52 3.52 0 0 1 9.5 22C7.57 22 6 20.43 6 18.5a3.52 3.52 0 0 1 2.722-3.413 1.001 1.001 0 0 0-.443-1.95A5.47 5.47 0 0 0 4.001 18.5c0 3.032 2.468 5.5 5.5 5.5a5.47 5.47 0 0 0 5.364-4.278 1 1 0 0 0-.754-1.197"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-music-note-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrMusicNoteSlash;
